import HeaderWebsite from "../../components/HeaderWebsite";
import HeaderAccountFree from "../../components/HeaderAccountFree";
import SubNavbar from "../../components/SubNavbar";
import MainNotFound from "../../components/MainNotFound";

export default function PageNotFound(props) {
  const {
    login,
    userData,
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    showHomeScreen,
  } = props;
  
  if (!showHomeScreen) {
    return null;
  }

  let headerType = null;
  let accountFeatures = [];
  try {
    accountFeatures = JSON.parse(userData?.account_features);
  } catch {
    accountFeatures = [];
  }
  const plano = userData?.plano?.toLocaleLowerCase() || "";
  const hasActivePlan =
    login === true &&
    accountFeatures.length > 0 &&
    plano !== "inativo" &&
    plano !== "gratuito";

  if (hasActivePlan) {
    headerType = "premiun";
  } else if (login === true && hasActivePlan === false) {
    headerType = "free";
  }

  if (login === true) {
    return (
      <>
        {headerType == "premiun" && (
          <HeaderWebsite
            statusMode={statusMode}
            setStatusMode={setStatusMode}
            isLoggedIn={isLoggedIn}
            showLogoutButton={showLogoutButton}
            notificationVolume={notificationVolume}
            setNotificationVolume={setNotificationVolume}
            userData={userData}
            user={userData}
          />
        )}

        {headerType == "free" && <HeaderAccountFree statusMode={statusMode} />}

        <MainNotFound />
      </>
    );
  }

  return (
    <>
    <SubNavbar statusMode={statusMode} setStatusMode={setStatusMode}/>
      <MainNotFound />
    </>
  );
}
